import {IClassNameProps} from '@bem-react/core';
import React from 'react';
import {cnCollectionDetail} from '../CollectionDetail';
import {ICollectionDto} from '../../../../../common-code/interfaces/ICollectionDto';
import {useTranslation} from 'react-i18next';
import {CurrencyHelper} from "../../../../../domain/CurrencyHelper/CurrencyHelper";
import {Button} from "../../../components/Button";
import {Link} from "../../../components/Link/Link";
import {LINK_TARGET_BLANK, LINK_TYPE_DEFAULT} from "../../../constants";
import {cnProjects} from "../../Projects/Projects";
import {useNavigate} from "react-router-dom";

export interface ICollectionDetailTemplateProjectsProps extends IClassNameProps {
    collection: ICollectionDto;
}

export const CollectionDetailTemplateProjects: React.FC<ICollectionDetailTemplateProjectsProps> = ({collection}) => {
    const {t} = useTranslation();
    const navigate = useNavigate();

    const navigateToProject = (projectId: string) => {
        navigate('/wizard/?project=' + projectId);
    }

    if (collection.templateProjects === undefined ||
        (Object.values(collection.templateProjects).length <= 0)) {
        return null;
    }

    return (
        <div className={cnCollectionDetail('Projects')}>
            <div className={cnCollectionDetail('Subtitle')}>
                {t('Примеры проектов кухонных гарнитуров')}:
            </div>
            <div className={cnCollectionDetail('ProjectsItems')}>
                {Object.values(collection.templateProjects).map((project) => {
                    return (
                        <div className={cnCollectionDetail('Project')}
                             key={project.id}>
                            <div className={cnProjects('ItemImages')}>
                                {!project.image || <img className={cnCollectionDetail('ItemImage')} src={project.image}
                                                        alt={project.name}/>}
                            </div>
                            <div className={cnCollectionDetail('ItemName')}>
                                {project.name}
                            </div>
                            <div className={cnCollectionDetail('ItemPrice')}>
                                <div className={cnCollectionDetail('ItemPriceTitle')}>
                                    {t('Цена')}:
                                </div>
                                <div className={cnCollectionDetail('ItemPriceValue')}>
                                    {CurrencyHelper.formatValue(project.price)}
                                </div>
                            </div>
                            <div className={cnCollectionDetail('ItemButtons')}>
                                {project.apiVersion === '3' ?
                                    <Button type={'button'}
                                            mods={{
                                                mods: {
                                                    bkg: 'white',
                                                    color: 'lightGreen',
                                                    fill: 'lightGreen',
                                                    border: 'green'
                                                },
                                                hover: {
                                                    mods: {
                                                        bkg: 'lightGreen',
                                                        color: 'white',
                                                        fill: 'white',
                                                        border: 'green'
                                                    }
                                                }
                                            }}
                                            callBack={() => {
                                                navigateToProject(project.id);
                                            }}
                                            leftIcon={{
                                                path: 'create',
                                                width: 12,
                                                height: 12,
                                                marginRight: 5
                                            }}
                                            className={cnCollectionDetail('Button', {type: 'item'})}
                                            text={t('Открыть') || ''}
                                    /> :
                                    <Link className={cnCollectionDetail('Button', {type: 'item'})}
                                          href={`https://3d.narod-kuhni.ru/wizard/?project=${project.id}`}
                                          type={LINK_TYPE_DEFAULT}
                                          target={LINK_TARGET_BLANK}>
                                        <Button type={'button'}
                                                mods={{
                                                    mods: {
                                                        bkg: 'white',
                                                        color: 'lightGreen',
                                                        fill: 'lightGreen',
                                                        border: 'green'
                                                    },
                                                    hover: {
                                                        mods: {
                                                            bkg: 'lightGreen',
                                                            color: 'white',
                                                            fill: 'white',
                                                            border: 'green'
                                                        }
                                                    }
                                                }}
                                                callBack={() => {
                                                }}
                                                leftIcon={{
                                                    path: 'create',
                                                    width: 12,
                                                    height: 12,
                                                    marginRight: 5
                                                }}
                                                className={cnCollectionDetail('Button', {type: 'item'})}
                                                text={t('Открыть') || ''}
                                        />
                                    </Link>}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}